export enum LanguageValue {
  ENGLISH = 'en-GB',
  GERMAN = 'de-DE',
  CZECH = 'cs-CZ',
  POLISH = 'pl-PL',
  POLISH_BDO = 'pl-PL-BDO',
}
